import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PriorityState } from "./types";

const initialState: PriorityState = {
  priority: false,
};

const prioritySlice = createSlice({
  name: 'priority',
  initialState,
  reducers: {
    setPriority(state, action: PayloadAction<boolean>) {
      state.priority = action.payload;
    },

    togglePriority(state) {
      state.priority = !state.priority;
    },

    clearPriorityState() {
      return initialState;
    }
  }
});

export const {
  setPriority,
  togglePriority,
  clearPriorityState
} = prioritySlice.actions;

export default prioritySlice.reducer;
